import {orgChartSvg as Icon__small__orgChartSvg} from '../Icon__small/Icon__small--orgChart.js';

export var orgChart = {
  name: 'orgChart',
  category: 'icon',
  colorable: true,
  svg: Icon__small__orgChartSvg,
};
